import React from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import { LanguageProvider, useLanguage } from '@/context/LanguageContext';
import { AuthProvider } from '@/context/AuthContext';
import LandingPage from '@/pages/LandingPage';
import SetupPage from '@/pages/SetupPage';
import TenantRegistrationStatusPage from '@/pages/TenantRegistrationStatusPage';
import SignInPage from '@/pages/SignInPage';
import DashboardPage from '@/pages/DashboardPage';
import ProtectedRoute from '@/components/ProtectedRoute';

const SUPPORTED_LANGS = ['en', 'tr'];

function LocalizedRedirect({ targetPath }) {
  const { pathFor } = useLanguage();
  const location = useLocation();
  return <Navigate to={`${pathFor(targetPath)}${location.search}${location.hash}`} replace />;
}

function LocalizedStatusRedirect() {
  const { registrationId = '' } = useParams();
  return <LocalizedRedirect targetPath={`/setup/status/${encodeURIComponent(registrationId)}`} />;
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LocalizedRedirect targetPath="/" />} />
            <Route path="/setup" element={<LocalizedRedirect targetPath="/setup" />} />
            <Route path="/setup/status/:registrationId" element={<LocalizedStatusRedirect />} />
            <Route path="/signin" element={<LocalizedRedirect targetPath="/signin" />} />
            <Route path="/dashboard" element={<LocalizedRedirect targetPath="/dashboard" />} />
            {SUPPORTED_LANGS.map((lang) => (
              <Route key={`${lang}-home`} path={`/${lang}`} element={<LandingPage />} />
            ))}
            {SUPPORTED_LANGS.map((lang) => (
              <Route key={`${lang}-setup`} path={`/${lang}/setup`} element={<SetupPage />} />
            ))}
            {SUPPORTED_LANGS.map((lang) => (
              <Route
                key={`${lang}-setup-status`}
                path={`/${lang}/setup/status/:registrationId`}
                element={<TenantRegistrationStatusPage />}
              />
            ))}
            {SUPPORTED_LANGS.map((lang) => (
              <Route key={`${lang}-signin`} path={`/${lang}/signin`} element={<SignInPage />} />
            ))}
            {SUPPORTED_LANGS.map((lang) => (
              <Route
                key={`${lang}-dashboard`}
                path={`/${lang}/dashboard`}
                element={(
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                )}
              />
            ))}
            <Route
              path="*"
              element={<LocalizedRedirect targetPath="/" />}
            />
          </Routes>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
